import NZContact from "../../../components/NZComponent/home/NZContact/NZContact";
import PETROLSIDE from "../../../assets/images/Double_Cab.jpg";
import { useNavigate } from "react-router";
import PETROLModels from "../../../components/NZComponent/NzPetrol/PETROLModels";
import HighLevelSpecs from "../../../components/NZComponent/NzPetrol/HighLevelSpecs";
import NZNZPetrolGregFarrier from "../../../components/NZComponent/NzPetrol/NZNZPetrolGregFarrier";
import NZElectricaTV from "../../../components/NZComponent/NzPetrol/NZElectricaTV";
import HomeIcon from "../../../assets/svg/HomeIcon.svg";
import RightSideArrow from "../../../assets/svg/RightSideArrow.svg";
import NZGregFarrier from "../../../components/NZComponent/home/NZGregFarrier/NZGregFarrier";
import NZGregAssociates from "../../../components/NZComponent/home/NZGregAssociates/NZGregAssociates";

import NZElectricDualModels from "../../../components/NZComponent/NzElectricDualMotor/NZElectricDualModels";
import NZElectricDualSpec from "../../../components/NZComponent/NzElectricDualMotor/NZElectricDualSpec";
import E_Logo from "../../../assets/images/E_Logo.png";
import { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
const NzElectricDualMotor = () => {
  let navigate = useNavigate();
  const textRef = useRef(null);
  const eRef = useRef(null);
  const [offset, setOffset] = useState(0);
  const [spacing, setSpacing] = useState(0);
  useEffect(() => {
    const handleResize = () => {
      if (textRef.current && eRef.current) {
        const textSize = window.getComputedStyle(textRef.current).fontSize;
        const textHeight = parseFloat(textSize); // Convert to number
        setOffset(textHeight * 0.1); // Adjust dynamically based on font size
        const eWidth = eRef.current.getBoundingClientRect().width;
        setSpacing(eWidth * 0.98);
      }
    };

    // Initial calculation
    handleResize();

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div>
        <div className="px-[12px] py-[6px] bg-[#F0F0F0] flex items-center">
          <img src={HomeIcon} alt="HomeIcon" className="cursor-pointer" onClick={() => navigate("/")} />
          <div className="flex items-center mx-[5px]">
            <img src={RightSideArrow} alt="RightSideArrow" />
            <img src={RightSideArrow} alt="RightSideArrow" />
          </div>
          <div className="text-[14px] leading-[24px] text-[#383838] montserrat-semi-bold">{`Electric Dual Motor / Dual Cabin`}</div>
        </div>
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-6 md:gap-10">
          <div className="w-full">
            <img
              src={PETROLSIDE}
              alt="Petrol Side"
              className="w-full h-[300px] sm:h-[400px] md:h-[600px] lg:h-[720px] object-cover"
            />
          </div>
          <div className="flex text-left px-6 md:px-12 lg:px-16 xl:px-20 py-8 md:py-24">
            <div
              className="text-white kuunari-bold 
             text-[20px] 
             md:text-[40px] 
             lg:text-[60px]  
             leading-[32px]
             md:leading-[42px] 
             lg:leading-[62px]
             mb-[11px]              
             max-w-[511px] 
             mx-auto"
              style={{ textShadow: "2px 4px 6px #000000" }}
            >
              <span ref={textRef} className="relative inline-block" style={{ paddingLeft: `${spacing}px` }}>
                <span
                  ref={eRef}
                  style={{ bottom: `${offset}px` }}
                  className="font-Dancing font-extrabold text-[#7bc25c] inline-block absolute left-0 
                  text-[22px] 
             md:text-[52px] 
             lg:text-[78px]  "
                >
                  e
                </span>
                Tuatara
              </span>{" "}
              - 6 Seat Double Cab, Dual Motor
            </div>
          </div>
        </div>
        <div className="bg-white">
          <div className="flex justify-center w-full py-[112px]">
            <p className="text-gray-600 text-[18px] font-medium leading-[28px] text-center max-w-[1160px] mx-auto">
              Our newest addition to the eTuarara family is our 6-seat double cab UTV, with its dual motors and larger
              capacity battery, making this vehicle a go anywhere people mover. It comes with a very innovative dual
              motor configuration, one on each axle, which dispenses with the need for a transmission or drive shafts.
              This significantly reduces driveline drag, resulting in an even quieter vehicle. It also reduces even
              further the maintenance items on the vehicle and therefore the costs associated with maintaining these
              items.
              <br />
              <br />
              The dual electric motors comprise a 15kW model on the rear axle and a 10kW motor on the front axle,
              providing a huge 25kW of total power, but amazingly, early testing suggests better economy than our
              current 15kW single motor model. We believe that this is likely due to the reduced driveline drag but also
              as a consequence of the constant traction provided by the motors working directly at the axles.
              <br />
              <br />
              Along with the significantly extra motor power that we have brought to the Double Cabin eTuatara is a
              hugely increased capacity 26.5kWh lithium iron phosphate battery. This battery is likely to provide a
              maximum range of up to 160kms., or possibly more.
              <br />
              <br />
              The Double Cabin eTuatara has the same go anywhere capability of all of our Tuatara models, and can also
              be fitted with a fully enclosed cabin, with fully opening glass windscreen with wiper and washer, as well
              as full or half doors, and can even be fitted with air conditioning with both warm and cold capability.
              <br />
              <br />
              {/* Working in the heat or cold? Not a problem, our TU-DC2500-2 model comes with air conditioning with a warm
              or cold function. Create an all-weather enclosed passenger cabin by adding a rear enclosure , full glass
              windscreen, and full doors, making the trip even more comfortable.
              <br />
              <br /> */}
              This vehicle would be ideal for adventure tourism or any commercial activity where there is a need to
              transport up to six passengers, in relative comfort and safety, over demanding terrain.
              <br />
              <br />
              The Double Cabin eTuatara is definitely breaking new ground.
            </p>
          </div>
        </div>
        <div>
          <NZElectricDualModels />
          <NZElectricDualSpec />
        </div>

        <NZGregFarrier
          bg={"#fff"}
          slogan="“THIS IS HANDS DOWN THE MOST VERSATILE ATV I HAVE PURCHASED FOR THE FARM.”"
        />
        <div id="contact-form">
          <NZContact />
        </div>
        {/* <NZGregAssociates /> */}
      </div>
    </>
  );
};
export default NzElectricDualMotor;
